import { createSlice } from "@reduxjs/toolkit";

const offersSlice = createSlice({
  name: "offers",
  initialState: {
    imageUrl: "",
  },
  reducers: {
    getImageUrl: (state, action) => {
      state.imageUrl = action.payload;
    },
  },
});

export const { getImageUrl } = offersSlice.actions;

export default offersSlice.reducer;
